var _style, _path, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgScroll1 = function SvgScroll1(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scroll_1_svg__scroll",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 371.4 665",
    style: {
      enableBackground: "new 0 0 371.4 665"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".scroll_1_svg__st0{fill:url(#scroll_1_svg__SVGID_1_)}.scroll_1_svg__st1{fill:url(#scroll_1_svg__SVGID_00000123418642861889934400000006688902802577042578_)}.scroll_1_svg__st2{fill:url(#scroll_1_svg__SVGID_00000142871028453915502360000002292177197347664298_)}.scroll_1_svg__st3{fill:url(#scroll_1_svg__SVGID_00000005976687464480731570000000911808148325584799_)}.scroll_1_svg__st4{fill:url(#scroll_1_svg__SVGID_00000034785108592177921140000005253767099360582565_)}.scroll_1_svg__st5{fill:url(#scroll_1_svg__SVGID_00000101084815179643301120000013482284454650735018_)}.scroll_1_svg__st6{fill:url(#scroll_1_svg__SVGID_00000029749334704836511330000004538202868982731929_)}.scroll_1_svg__st7{opacity:0.5}.scroll_1_svg__st8{fill:#F2F2F2}.scroll_1_svg__st9{fill:url(#scroll_1_svg__SVGID_00000141429042455380262110000017072592341414545834_)}.scroll_1_svg__st10{fill:url(#scroll_1_svg__SVGID_00000127764339148387536130000018266613981222444198_)}.scroll_1_svg__st11{fill:url(#scroll_1_svg__SVGID_00000139973034766888311310000000246284318258653627_)}.scroll_1_svg__st12{fill:url(#scroll_1_svg__SVGID_00000106869797123902129590000011147970527384029878_)}.scroll_1_svg__st13{fill:url(#scroll_1_svg__SVGID_00000090260508949492496040000002493182509282247587_)}.scroll_1_svg__st14{fill:url(#scroll_1_svg__SVGID_00000168832459944106941120000013147460862560765105_)}.scroll_1_svg__st15{fill:url(#scroll_1_svg__SVGID_00000077323787906771173700000000240913600589926844_)}.scroll_1_svg__st16{fill:url(#scroll_1_svg__SVGID_00000043458188454127893280000013836335976817252243_)}.scroll_1_svg__st17{fill:url(#scroll_1_svg__SVGID_00000150801695067111464350000013933008078068141191_)}.scroll_1_svg__st18{fill:url(#scroll_1_svg__SVGID_00000043437219332173480310000006204295737168073110_)}.scroll_1_svg__st19{fill:url(#scroll_1_svg__SVGID_00000107570597878109790620000012796226425038678962_)}.scroll_1_svg__st20{fill:url(#scroll_1_svg__SVGID_00000023279722477370172500000015608455885904878224_)}.scroll_1_svg__st21{fill:url(#scroll_1_svg__SVGID_00000139995951955207477840000016766053790995687324_)}.scroll_1_svg__st22{fill:url(#scroll_1_svg__SVGID_00000181063737845417395460000005829263414072979861_)}.scroll_1_svg__st23{fill:url(#scroll_1_svg__SVGID_00000008118284851561944290000017927410742598848951_)}.scroll_1_svg__st24{fill:url(#scroll_1_svg__SVGID_00000168082958440714726560000016379779535314621585_)}.scroll_1_svg__st25{fill:url(#scroll_1_svg__SVGID_00000025400347377942932120000006514858163686663553_)}.scroll_1_svg__st26{fill:url(#scroll_1_svg__SVGID_00000012442390450086061650000003930780660370430647_)}.scroll_1_svg__st27{fill:url(#scroll_1_svg__SVGID_00000078758127088477303490000012281820063300515207_)}.scroll_1_svg__st28{fill:url(#scroll_1_svg__SVGID_00000062154744244696430220000008906452467537355658_)}.scroll_1_svg__st29{fill:url(#scroll_1_svg__SVGID_00000144309366827033787330000006849159260199687086_)}.scroll_1_svg__st30{fill:url(#scroll_1_svg__SVGID_00000029742093986709500520000002807386642482252215_)}.scroll_1_svg__st31{fill:url(#scroll_1_svg__SVGID_00000105401856625156438480000001457020434529396121_)}.scroll_1_svg__st32{fill:url(#scroll_1_svg__SVGID_00000085961960236005347540000018077404863451113869_)}.scroll_1_svg__st33{fill:url(#scroll_1_svg__SVGID_00000114044687957991212780000009283977838086629796_)}.scroll_1_svg__st34{fill:url(#scroll_1_svg__SVGID_00000161628901692132849870000009045804838096330930_)}.scroll_1_svg__st35{fill:url(#scroll_1_svg__SVGID_00000119805008940397613700000013387240735515997111_)}.scroll_1_svg__st36{fill:url(#scroll_1_svg__SVGID_00000129174144685021430020000010645656773328925617_)}.scroll_1_svg__st37{fill:url(#scroll_1_svg__SVGID_00000072960407647395390510000008329322066185063062_)}.scroll_1_svg__st38{fill:url(#scroll_1_svg__SVGID_00000023258181141068550350000013845005325804561558_)}.scroll_1_svg__st39{fill:url(#scroll_1_svg__SVGID_00000122704014810612854240000008440272701256764314_)}.scroll_1_svg__st40{fill:url(#scroll_1_svg__SVGID_00000169525489297251380460000001300677796039549330_)}.scroll_1_svg__st41{fill:url(#scroll_1_svg__SVGID_00000016043792865463526380000000482295757582356616_)}.scroll_1_svg__st42{fill:url(#scroll_1_svg__SVGID_00000097494357520099933810000000083732679083684538_)}.scroll_1_svg__st43{fill:url(#scroll_1_svg__SVGID_00000128460697219111365160000018441084022193441722_)}.scroll_1_svg__st44{fill:url(#scroll_1_svg__SVGID_00000147930243696444355550000009063229007743601308_)}.scroll_1_svg__st45{fill:url(#scroll_1_svg__SVGID_00000162344282779202534040000017645868063835724162_)}.scroll_1_svg__st46{fill:url(#scroll_1_svg__SVGID_00000001665286947249882350000009969164879303732881_)}.scroll_1_svg__st47{fill:url(#scroll_1_svg__SVGID_00000024705596051501468210000001927506283920379813_)}.scroll_1_svg__st48{fill:url(#scroll_1_svg__SVGID_00000076601867740028983450000014129500908565288346_)}.scroll_1_svg__st49{fill:url(#scroll_1_svg__SVGID_00000024709992933192901390000017447071387063595439_)}.scroll_1_svg__st50{fill:url(#scroll_1_svg__SVGID_00000078014890216674647390000017027827164618174876_)}.scroll_1_svg__st51{fill:url(#scroll_1_svg__SVGID_00000175304160858211089190000006035943939123993750_)}.scroll_1_svg__st52{fill:url(#scroll_1_svg__SVGID_00000078747790657576212520000015619785650397106341_)}.scroll_1_svg__st53{fill:url(#scroll_1_svg__SVGID_00000000942506057132934840000005081968487698567063_)}.scroll_1_svg__st54{fill:url(#scroll_1_svg__SVGID_00000127017303616020624870000000261694284136013700_)}.scroll_1_svg__st55{fill:url(#scroll_1_svg__SVGID_00000058549074507039791470000016498977788832394646_)}.scroll_1_svg__st56{fill:url(#scroll_1_svg__SVGID_00000178177493449322436370000006684093727322658193_)}.scroll_1_svg__st57{fill:url(#scroll_1_svg__SVGID_00000096760546646574788400000017127090944845622164_)}.scroll_1_svg__st58{fill:url(#scroll_1_svg__SVGID_00000020383548743344409300000016767920466009867666_)}.scroll_1_svg__st59{fill:url(#scroll_1_svg__SVGID_00000167383664824813109760000010985573448075417486_)}.scroll_1_svg__st60{fill:url(#scroll_1_svg__SVGID_00000154383518730215309090000012070313224264876208_)}.scroll_1_svg__st61{fill:url(#scroll_1_svg__SVGID_00000058553230972509404720000006523585849618229139_)}.scroll_1_svg__st62{fill:url(#scroll_1_svg__SVGID_00000023276323349343349390000002402859105013279873_)}.scroll_1_svg__st63{fill:url(#scroll_1_svg__SVGID_00000067936294253044459710000006751779435500468388_)}.scroll_1_svg__st64{fill:url(#scroll_1_svg__SVGID_00000137817455897557916790000009663612540731369122_)}.scroll_1_svg__st65{fill:url(#scroll_1_svg__SVGID_00000003804134286669939340000012605004678013363842_)}.scroll_1_svg__st66{fill:url(#scroll_1_svg__SVGID_00000117675012933164222460000011553237534655349181_)}")), /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__bgc"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "scroll_1_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.2033,
    y1: -690.728,
    x2: 326.2411,
    y2: -301.9089,
    gradientTransform: "matrix(1 0 0 1 0 842.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#70E29C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5168,
    style: {
      stopColor: "#58B8C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E88C9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st0",
    d: "M351,295c-6.3-30.7-12.7-61.3-19-92L249,83l-15-31L187,8l-69.5,96.1l-33.9,92.2C58.8,243.7,34,291.1,9.1,338.5 L103,524l20.2,82.1c7.9,13.3,15.8,26.6,23.8,39.9l30,13l36-49l109-97c4.3-17,8.7-34,13-51l15-22c5.3-13,10.7-26,16-39L351,295z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg___Layer_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000020358468819425285640000018101367291010937500_",
    cx: 242.9019,
    cy: 321.2921,
    r: 134.5754,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1848,
    style: {
      stopColor: "#17C9B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7386,
    style: {
      stopColor: "#58D9AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#71DFA9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000020358468819425285640000018101367291010937500_)"
    },
    d: "M273,139c-5.7,24-11.3,48-17,72l8,2 l65-12l6-2l-17-19L273,139z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000114072598520205011180000014329860050845726384_",
    cx: 335.4467,
    cy: 276.6349,
    r: 138.7992,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04C0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5589,
    style: {
      stopColor: "#2AD4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#43E2AB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000114072598520205011180000014329860050845726384_)"
    },
    d: "M272,119c0.3,6.7,0.7,13.3,1,20l62,60 l-53-70L272,119z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000137845290072541176210000007271733320649992880_",
    cx: 333.2845,
    cy: 285.3342,
    r: 194.5211,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C1BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    style: {
      stopColor: "#2AD9A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#43E89A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000137845290072541176210000007271733320649992880_)"
    },
    d: "M253,79c6.3,13.7,12.7,27.3,19,41 c40.9,53.5,61.9,79.8,63,79C336.3,198,309,158,253,79z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000021835537316221710740000005679714282768703623_",
    cx: 270.4313,
    cy: 293.8131,
    r: 118.59,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CD3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2731,
    style: {
      stopColor: "#68D4B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5499,
    style: {
      stopColor: "#5CD5B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8274,
    style: {
      stopColor: "#48D8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#37DABC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000021835537316221710740000005679714282768703623_)"
    },
    d: "M335,199l-3,4l-34,26l-3,1l-39-19 L335,199z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000021832981866428369630000011019799900255842465_",
    cx: 310.8354,
    cy: 318.1465,
    r: 159.6755,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76EAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6760FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000021832981866428369630000011019799900255842465_)"
    },
    d: "M335,199l-40,31l35,29l3-10 c0.7-14.7,1.3-29.3,2-44V199z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000118386776217890070000000010408168892551329426_",
    cx: 309.0659,
    cy: 362.5941,
    r: 167.811,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4DC6BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    style: {
      stopColor: "#51C3BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    style: {
      stopColor: "#5DBABF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    style: {
      stopColor: "#72AAC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    style: {
      stopColor: "#8E94C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E88C9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000118386776217890070000000010408168892551329426_)"
    },
    d: "M335,199c-1.7,20-3.3,40-5,60l25,35 C348.3,262.3,341.7,230.7,335,199z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__highlights",
    className: "scroll_1_svg__st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M335,199c8.1,38.6,12.1,58,12,58s-4.1-18.3-12-55l-3,30c0.7-10.7,1.3-21.3,2-32l-25,19l24-20l-14-15 l12.1,11.3C332.4,196.6,333.7,197.8,335,199z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__shapes_copy_5"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000154425974921046695540000018004789900968229519_",
    cx: -350.8964,
    cy: 171.8213,
    r: 221.1684,
    gradientTransform: "matrix(-3.310104e-02 -0.9995 -0.9995 3.310104e-02 256.8521 -109.6704)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFF5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    style: {
      stopColor: "#99F77A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    style: {
      stopColor: "#57F18C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EEF93"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000154425974921046695540000018004789900968229519_)"
    },
    d: "M115,101l6,23l52,56l17-5 c3.3-13.7,6.7-27.3,10-41l-79-32L115,101z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000030453208703245372060000002243386830646951825_",
    cx: -334.2819,
    cy: 118.6064,
    r: 122.5169,
    gradientTransform: "matrix(-3.310104e-02 -0.9995 -0.9995 3.310104e-02 256.8521 -109.6704)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFF40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    style: {
      stopColor: "#99F76C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    style: {
      stopColor: "#57F188"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EEF93"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000030453208703245372060000002243386830646951825_)"
    },
    d: "M115,101l74.2-2.7l1.8,2.7 c1.7,10.7,3.3,21.3,5,32v4L115,101z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000134237865176714673120000012569315936004558227_",
    cx: -145.4803,
    cy: 161.8322,
    r: 129.6362,
    gradientTransform: "matrix(-3.310104e-02 -0.9995 -0.9995 3.310104e-02 256.8521 -109.6704)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    style: {
      stopColor: "#A0F576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8301,
    style: {
      stopColor: "#5EF9B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45FBCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000134237865176714673120000012569315936004558227_)"
    },
    d: "M115,101l74.2-2.7L193,93l3.3-21.9L187,0 L115,101z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000179627170864856156100000015858397332184225417_",
    cx: 134.8775,
    cy: 288.0128,
    r: 149.4797,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEE60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4754,
    style: {
      stopColor: "#A0F596"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8326,
    style: {
      stopColor: "#5EF9BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45FBCA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000179627170864856156100000015858397332184225417_)"
    },
    d: "M186.6,252.4 c-4.6-24.2-9.1-48.3-13.7-72.5L187,172l1,2c-0.3,25.3-0.7,50.7-1,76L186.6,252.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000149349218422751932290000006560893241476896910_",
    cx: 325.8546,
    cy: 300.7191,
    r: 173.0918,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C9F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4345,
    style: {
      stopColor: "#50DAC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8196,
    style: {
      stopColor: "#92E99C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABEE8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000149349218422751932290000006560893241476896910_)"
    },
    d: "M204,260c3.7-8.3,7.3-16.7,11-25l1-4 l-18-89l-2-5l-9,35l-0.4,80.4l2.4,2.6l13,6L204,260z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000119106854485044453500000014165060592336429210_",
    cx: 115.7178,
    cy: 274.3641,
    r: 159.8339,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8E0AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0649,
    style: {
      stopColor: "#C1E1AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7003,
    style: {
      stopColor: "#80ECA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#67F0A5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000119106854485044453500000014165060592336429210_)"
    },
    d: "M186.6,252.4L193,336 c3.7-25.3,7.3-50.7,11-76L186.6,252.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000054956185451169540110000013371615345518016392_",
    cx: 117.3475,
    cy: 436.0558,
    r: 70.5853,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#64F968"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1919,
    style: {
      stopColor: "#6AF66F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7FE988"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000054956185451169540110000013371615345518016392_)"
    },
    d: "M196,71l21.2-1.6c1.3-1,2.6-2,3.9-3.1 c6-5,11.5-10.5,16.5-16.6L187,0L196,71z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000021116269448390582260000001599916113987924414_",
    cx: 313.6194,
    cy: 414.5233,
    r: 132.9737,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B5BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    style: {
      stopColor: "#2AD5A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#43E89A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000021116269448390582260000001599916113987924414_)"
    },
    d: "M196,71l3,4l71,44h3 c-5.5-11.4-11.2-23.1-17.3-34.9c-6-11.8-12.1-23.3-18.1-34.4L196,71z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000128450910886320796260000017678430150721885610_",
    cx: 334.2343,
    cy: 318.7426,
    r: 174.4837,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B5BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    style: {
      stopColor: "#2AD7B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#43EBAB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000128450910886320796260000017678430150721885610_)"
    },
    d: "M196,71l77,48.5v20l-2,0.5l-67-32 c-2.7-11.3-5.3-22.7-8-34V71z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000136413938501946054350000002864661826601331098_",
    cx: 303.5304,
    cy: 273.0936,
    r: 143.0893,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    style: {
      stopColor: "#2ADAA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#43E89A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000136413938501946054350000002864661826601331098_)"
    },
    d: "M205,107l68,32.5 c-5.7,24.8-11.3,49.7-17,74.5l-3-1l-54-69l-3-7c0.3-2.7,0.7-5.3,1-8l7-21L205,107z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000152950810620227040800000006709913622973641090_",
    cx: 350.3977,
    cy: 202.5495,
    r: 276.2517,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CD1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3563,
    style: {
      stopColor: "#39C2B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7934,
    style: {
      stopColor: "#7AEC95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#93FD89"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000152950810620227040800000006709913622973641090_)"
    },
    d: "M196,137c6.3,32.7,12.7,65.3,19,98l41-21 L196,137z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000069376033330424460270000007393975081041215412_",
    cx: 229.6051,
    cy: 364.9669,
    r: 79.8852,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#34E09F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6478,
    style: {
      stopColor: "#6CF27C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85FA6C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000069376033330424460270000007393975081041215412_)"
    },
    d: "M205,107l-9,30 c-2.3-12.9-4.6-25.8-6.8-38.7c2.3-9.1,4.6-18.2,6.8-27.3L205,107z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__highlights_copy_2",
    className: "scroll_1_svg__st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M187,0l17,17L188,2l3,30c-1.3-10-2.7-20-4-30c-12.5,16.8-18.8,25.1-19,25S174.2,17.9,187,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M195,75l-7,22l-40,3l40-1l6,29c-1.3-10-2.7-20-4-30C191.7,90.3,193.3,82.7,195,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M245,126l28,13c-2.7,12-5.3,24-8,36c2.3-11.7,4.7-23.3,7-35L245,126z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg___Layer_2"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000133528835008286510340000018382871358189374346_",
    cx: 9.8529,
    cy: 300.5757,
    r: 148.9581,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDFF40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0381,
    style: {
      stopColor: "#E4FE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    style: {
      stopColor: "#83F171"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8452,
    style: {
      stopColor: "#4DE8A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#34E5AD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000133528835008286510340000018382871358189374346_)"
    },
    d: "M121,118c0.3,7,0.7,14,1,21 c5.7,26.7,11.3,53.3,17,80l32-30c0.7-3,1.3-6,2-9L121,118z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000099633257804194688210000003820278773429958072_",
    cx: 169.022,
    cy: 90.7711,
    r: 203.9856,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B8AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    style: {
      stopColor: "#25C6AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7646,
    style: {
      stopColor: "#66DFA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7FE9A7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000099633257804194688210000003820278773429958072_)"
    },
    d: "M173,180c7.3,25.5,14.7,51,22,76.5 c1.7,10,3.3,20,5,30c-1.3,15.2-2.7,30.4-4,45.5l-3-2l-39-52l-14.3-61.8L173,180z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000057831209686122296710000002138047590815567232_",
    cx: 253.7126,
    cy: 125.6993,
    r: 300.5038,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A6B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2712,
    style: {
      stopColor: "#35C4BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7662,
    style: {
      stopColor: "#67DEAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#80E8A5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000057831209686122296710000002138047590815567232_)"
    },
    d: "M156,281c-5.5,14.9-11.2,29.9-17,45 c-7.6,19.7-15.3,39-23,58L7,344l-7-4l121-222C132.7,172.3,144.3,226.7,156,281z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000103943897130637749920000002431119764024541877_",
    cx: 208.0294,
    cy: 56.1235,
    r: 243.959,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CBAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6858,
    style: {
      stopColor: "#43BBA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CBD90"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000103943897130637749920000002431119764024541877_)"
    },
    d: "M27,390L0,340l115.5,41.9l0.5,5.1l-6,58 l-3,7L27,390z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000098202342115321920600000018312793895889031358_",
    cx: 102.4335,
    cy: 158.7234,
    r: 159.0826,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6AE8D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FB587"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000098202342115321920600000018312793895889031358_)"
    },
    d: "M144.6,369.4L161,341l50,65L144.6,369.4z "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000103952470087445173060000012204906381678655147_",
    cx: 167.7123,
    cy: -23.2319,
    r: 161.0665,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#45A2AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    style: {
      stopColor: "#52BBAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6BD2AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000103952470087445173060000012204906381678655147_)"
    },
    d: "M115,382c-2.7,23.3-5.3,46.7-8,70l15-5 l81-35l8-6l-63-37L115,382z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000044879636367072768030000007295179841951395500_",
    cx: 108.7415,
    cy: 119.6173,
    r: 129.7146,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2CC2AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3906,
    style: {
      stopColor: "#56BEB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5ABAC2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000044879636367072768030000007295179841951395500_)"
    },
    d: "M211,406c-34.7,14.7-69.3,29.3-104,44 c0,0.7,0,1.3,0,2c19.3,2.7,38.7,5.3,58,8c12.6-5.4,25.3-10.8,37.9-16.2C205.6,431.2,208.3,418.6,211,406z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000060733919145934961630000010920357377576983703_",
    cx: 318.0044,
    cy: 132.3183,
    r: 211.135,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A091"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2554,
    style: {
      stopColor: "#23B29E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7612,
    style: {
      stopColor: "#64D4B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DE1C0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000060733919145934961630000010920357377576983703_)"
    },
    d: "M160,341l-6-58c0.3-2,0.7-4,1-6l41,55 l15,74L160,341z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000021825516826435920740000006207517975295973007_",
    cx: 174.033,
    cy: 72.4175,
    r: 373.2329,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6AE8C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6FB587"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000021825516826435920740000006207517975295973007_)"
    },
    d: "M155,277c-6.2,16.7-12.5,33.5-18.8,50.2 c-6.9,18.2-13.8,36.5-20.7,54.7L147,369l14.2-26.7L155,277z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000034810982404037732400000004903245005319137938_",
    cx: 105.0364,
    cy: 412.9224,
    r: 82.0429,
    gradientTransform: "matrix(0.9971 7.596211e-02 9.962880e-02 -1.3078 -40.8355 608.9962)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CEF5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#43EBBE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000034810982404037732400000004903245005319137938_)"
    },
    d: "M79,195l42-77l-6-17L79,195z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000074419308835341820630000000077087855094245009_",
    cx: 223.4436,
    cy: -31.9586,
    r: 116.9575,
    fx: 115.3516,
    fy: -76.6259,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CA4CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4171,
    style: {
      stopColor: "#5FB3C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51C3C4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000074419308835341820630000000077087855094245009_)"
    },
    d: "M161.8,461.4c13.3-6,26.7-12.1,40-18.1 c-3.6,9.8-7.3,19.6-10.9,29.5C181.2,469,171.5,465.2,161.8,461.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__highlights_copy_3",
    className: "scroll_1_svg__st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M156,277l3,42c-1.3-13.3-2.7-26.7-4-40l-13,33l12-35c-6.3-31.3-9.3-46.9-9-47S149,245.6,156,277z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M116,380l-32-9l30,12c-0.7,8.3-1.3,16.7-2,25c1.7-8.3,3.3-16.7,5-25l31-13l9-19l-10,18L116,380z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M22,300L4,339l57,23L4,343l19,39L0,340L22,300z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__left-bottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg___Layer_3"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000026861869064554607730000001122335760649437099_",
    cx: -120.4403,
    cy: 14.0562,
    r: 225.4248,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6E473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FBFC4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000026861869064554607730000001122335760649437099_)"
    },
    d: "M107,450l-6,76l-1.3,1.8 C74.8,480.9,49.9,433.9,25,387L107,450z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000140016818867612213770000002990420464223032722_",
    cx: 144.6824,
    cy: 98.0792,
    r: 185.2717,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4FEAA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8087FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000140016818867612213770000002990420464223032722_)"
    },
    d: "M107,450l5,7l61,51l5,1.5 c3.9-12.8,7.7-25.7,11.6-38.5c-7-4.3-14-8.6-21-12.9C148.1,455.4,127.5,452.7,107,450z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000111157161289127203360000013867012032921399208_",
    cx: 69.4831,
    cy: 23.9321,
    r: 137.2539,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#72C2BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2444,
    style: {
      stopColor: "#71C0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    style: {
      stopColor: "#6FBACD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    style: {
      stopColor: "#6BAFE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9906,
    style: {
      stopColor: "#66A1FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#66A0FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000111157161289127203360000013867012032921399208_)"
    },
    d: "M107,450c-0.3,2.3-0.7,4.7-1,7l15,84 c15.7-7.6,31.7-16.2,48-26c3-1.8,6-3.7,9-5.5L107,450z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000146471680967157859800000011146462891785591965_",
    cx: 5.2675,
    cy: -56.3804,
    r: 155.4494,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2DC6BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1933,
    style: {
      stopColor: "#31C4BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3894,
    style: {
      stopColor: "#3DBEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5866,
    style: {
      stopColor: "#52B3C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7848,
    style: {
      stopColor: "#6EA5CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9819,
    style: {
      stopColor: "#9292D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9690D2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000146471680967157859800000011146462891785591965_)"
    },
    d: "M178,509.5l-7,16.5l-44,80l-6,7 c-0.3-4.7-0.7-9.3-1-14v-54l2-5L178,509.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000005264025252459425080000015623628784739644038_",
    cx: 183.984,
    cy: -75.9849,
    r: 170.0956,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97AAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    style: {
      stopColor: "#61C7C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#48D5B9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000005264025252459425080000015623628784739644038_)"
    },
    d: "M99.7,527.8c1.1,1.4,2.2,2.8,3.3,4.2 l15,9l4-1l-15-90l0,0L99.7,527.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000096027122393151206500000011287140252564656285_",
    cx: 50.1789,
    cy: -55.5427,
    r: 73.7703,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4DC6BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2565,
    style: {
      stopColor: "#51C4C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5165,
    style: {
      stopColor: "#5DBDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7771,
    style: {
      stopColor: "#71B1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#89A4E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000096027122393151206500000011287140252564656285_)"
    },
    d: "M122,540c-0.3,24.3-0.7,48.7-1,73 c-7.1-28.4-14.2-56.8-21.3-85.2L122,540z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scroll_1_svg__SVGID_00000075139390833098262030000014183558922566735283_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.711,
    y1: -82.1987,
    x2: 168.9376,
    y2: -68.6896,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2AB8C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#897AC2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000075139390833098262030000014183558922566735283_)"
    },
    d: "M177,510l-56,103l5-2l24-23l4-5 C161.7,558.7,169.3,534.3,177,510z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000090265913619063948240000004100369137913493392_",
    cx: 32.6804,
    cy: -109.262,
    r: 119.5325,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#79C6BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#79C2BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3702,
    style: {
      stopColor: "#78B6BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5578,
    style: {
      stopColor: "#76A1C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    style: {
      stopColor: "#7485C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    style: {
      stopColor: "#7161C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7052C9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000090265913619063948240000004100369137913493392_)"
    },
    d: "M154,583l-33,30l26,39 C149.3,629,151.7,606,154,583z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__highlights-2",
    className: "scroll_1_svg__st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M115,496c2.7,14.3,5.3,28.7,8,43l32-17l-32,19c-0.3,8.7-0.7,17.3-1,26c-0.3-9-0.7-18-1-27L115,496z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M121,613l11,16l-9-16l20-20L121,613z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__right-bottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg___Layer_4"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000156566905622123920240000000761089642330423972_",
    cx: 243.1593,
    cy: 130.9669,
    r: 111.199,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55BAB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3059,
    style: {
      stopColor: "#5DC3B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7972,
    style: {
      stopColor: "#75DAB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#80E6B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000156566905622123920240000000761089642330423972_)"
    },
    d: "M215,234l3,3l9,103l-34-9 c3.3-23.5,6.7-47,10-70.5L215,234z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000000931330107790194720000013905061615396662442_",
    cx: 308.8288,
    cy: 291.0237,
    r: 88.2215,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#65D4B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#57C4C0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000000931330107790194720000013905061615396662442_)"
    },
    d: "M256,211l26,25l14-7L256,211z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000009591042484102158520000013252638851683201471_",
    cx: 337.4492,
    cy: 240.1322,
    r: 48.6295,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#609FCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59C4C0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000009591042484102158520000013252638851683201471_)"
    },
    d: "M296,229l-14,5l45,38l3-15L296,229z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000047765254170827979280000013297679029896461467_",
    cx: 380.8681,
    cy: 220.647,
    r: 78.6099,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9282C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59B6C0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000047765254170827979280000013297679029896461467_)"
    },
    d: "M355,294c-8.3-12.3-16.7-24.7-25-37 c-1.7,5-3.3,10-5,15l11,11L355,294z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000122705996596310284320000004983945733025293471_",
    cx: 160.8242,
    cy: 165.6797,
    r: 184.792,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4EE5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8A5DD6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000122705996596310284320000004983945733025293471_)"
    },
    d: "M226,339l-33-8c9.3,19.7,18.7,39.3,28,59 l33-9L226,339z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000076585889421437472180000017212076157515799486_",
    cx: 150.956,
    cy: 159.846,
    r: 166.2905,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4EDDB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8360CA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000076585889421437472180000017212076157515799486_)"
    },
    d: "M247,380l-22,8l13,6l52,16L247,380z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000017518924779314388860000007642672909749522056_",
    cx: 189.6142,
    cy: 294.2443,
    r: 265.9925,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4DD6BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1924,
    style: {
      stopColor: "#4FD2BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3875,
    style: {
      stopColor: "#57C6C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5838,
    style: {
      stopColor: "#63B1C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    style: {
      stopColor: "#7495C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9772,
    style: {
      stopColor: "#8971C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C6CC8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000017518924779314388860000007642672909749522056_)"
    },
    d: "M371.4,404H368l-57-65 c-20.6-38.1-38-78-52-119c-1-3-2-6-3-9l33,21l39,33l27,29C360.5,330.7,365.9,367.3,371.4,404z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000120556458868832429730000012628089329045121162_",
    cx: 388.1868,
    cy: 56.6841,
    r: 179.4429,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#924396"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5ABDEA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000120556458868832429730000012628089329045121162_)"
    },
    d: "M357,443c4.8-13,9.6-26,14.4-39 c-19.8-22-39.6-44-59.4-66l-10,9l-18,54l3,10L357,443z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000008142606787123546740000013899362828655423120_",
    cx: 173.4861,
    cy: 46.2592,
    r: 138.2808,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4EC1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#60AFC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4578,
    style: {
      stopColor: "#759CD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    style: {
      stopColor: "#8190DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#858CE2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000008142606787123546740000013899362828655423120_)"
    },
    d: "M286,408l2,8c-1.3,10.3-2.7,20.7-4,31 l-107,63c1.7-6.7,4.6-17.9,6.3-24.6c0.8-3,3.2-12.4,4-15.5c3.9-8.2,7.8-16.4,11.7-24.5l6-4.5l68-30L286,408z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000026146460785259185650000005947375157310305471_",
    cx: 361.6813,
    cy: 27.7142,
    r: 127.4927,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#714AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2931,
    style: {
      stopColor: "#885CB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7444,
    style: {
      stopColor: "#A673C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B17CC6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000026146460785259185650000005947375157310305471_)"
    },
    d: "M339.9,464.5L357,443l-71-35l3,8l46,46 L339.9,464.5z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000003802550467592908810000008075847101564501940_",
    cx: 429.6263,
    cy: 9.0329,
    r: 156.6053,
    gradientTransform: "matrix(0.9974 7.224773e-02 7.224773e-02 -0.9974 -23.0958 489.7056)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C49C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#6F4DC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    style: {
      stopColor: "#7659C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    style: {
      stopColor: "#836ED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    style: {
      stopColor: "#958ADC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C94E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000003802550467592908810000008075847101564501940_)"
    },
    d: "M286,408c-2.7,13.3-5.3,26.7-8,40 c0.7,2.3,1.3,4.7,2,7l42,58l3.2,1.6c4.9-16.7,9.8-33.4,14.7-50.1L286,408z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000026864968687858614760000014851056168793188773_",
    cx: 341.9011,
    cy: -96.11,
    r: 184.7468,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9685D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3109,
    style: {
      stopColor: "#9286D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6259,
    style: {
      stopColor: "#8689D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    style: {
      stopColor: "#728DD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D8ED9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000026864968687858614760000014851056168793188773_)"
    },
    d: "M278,448l-101,62l88,25 c4.7-27.7,9.3-55.3,14-83L278,448z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000163788537895944445700000002167459784981730713_",
    cx: 372.8885,
    cy: -16.4802,
    r: 135.2652,
    gradientTransform: "matrix(0.9974 7.224773e-02 7.224773e-02 -0.9974 -23.0958 489.7056)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9062D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2373,
    style: {
      stopColor: "#9066D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4778,
    style: {
      stopColor: "#8F72D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7198,
    style: {
      stopColor: "#8E87CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    style: {
      stopColor: "#8DA3CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8DA8C9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000163788537895944445700000002167459784981730713_)"
    },
    d: "M278,448c-4.7,30-9.3,60-14,90l49-17 l12.2-6.4L278,448z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000087403782470536811370000016491576715673923478_",
    cx: 272.0877,
    cy: -106.2928,
    r: 211.1568,
    gradientTransform: "matrix(0.9974 7.224773e-02 7.224773e-02 -0.9974 -23.0958 489.7056)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B6AD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2523,
    style: {
      stopColor: "#6D6ED3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    style: {
      stopColor: "#747AD1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7644,
    style: {
      stopColor: "#7F8ECE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8DA8C9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000087403782470536811370000016491576715673923478_)"
    },
    d: "M265,533l-30,38l-48-48l-10-13L265,533z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000016076747081069082740000007897769314648228527_",
    cx: 290.9249,
    cy: -253.1678,
    r: 314.906,
    gradientTransform: "matrix(0.9974 7.224773e-02 7.224773e-02 -0.9974 -23.0958 489.7056)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7835C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#7739C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    style: {
      stopColor: "#7345C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5461,
    style: {
      stopColor: "#6E5AC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7306,
    style: {
      stopColor: "#6676C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9141,
    style: {
      stopColor: "#5C9AC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#56AEC4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000016076747081069082740000007897769314648228527_)"
    },
    d: "M177,510l59,60 c-6.3,13.7-12.7,27.3-19,41l-2,3c-11.3-23.7-21-48-29-73C182.6,530.4,179.6,520.1,177,510z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000042734024899601260160000002332865443928947878_",
    cx: 291.4593,
    cy: -52.9852,
    r: 118.0265,
    gradientTransform: "matrix(0.9974 7.224773e-02 7.224773e-02 -0.9974 -23.0958 489.7056)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A43C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    style: {
      stopColor: "#5E47C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4332,
    style: {
      stopColor: "#6A52C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6526,
    style: {
      stopColor: "#7F66CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8718,
    style: {
      stopColor: "#9B81D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AF94E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000042734024899601260160000002332865443928947878_)"
    },
    d: "M190.6,588.4L215,614l-38-104 C181.5,536.1,186,562.3,190.6,588.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000076601312539395025420000004116639022675800194_",
    cx: 226.2209,
    cy: 40.3491,
    r: 159.2193,
    gradientTransform: "matrix(0.9974 7.224773e-02 7.224773e-02 -0.9974 -23.0958 489.7056)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A49C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    style: {
      stopColor: "#5E4DC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    style: {
      stopColor: "#6859C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    style: {
      stopColor: "#7A6ED0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    style: {
      stopColor: "#938ADC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C94E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000076601312539395025420000004116639022675800194_)"
    },
    d: "M325.2,515L265,533l-30,36l-20,45 L325.2,515z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000077300456863857294120000010838303570106885508_",
    cx: 220.4531,
    cy: 256.4579,
    r: 207.9767,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4DD0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    style: {
      stopColor: "#50CAB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    style: {
      stopColor: "#59B8C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8838,
    style: {
      stopColor: "#679BCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D90D2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000077300456863857294120000010838303570106885508_)"
    },
    d: "M256,211l-41,23c3.7,35,7.3,70,11,105 l72,4l14-4L256,211z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000012452438618919167670000015260494648000304524_",
    cx: 223.0001,
    cy: 192.4085,
    r: 119.0866,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4DBCBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2544,
    style: {
      stopColor: "#50B8BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#59ACC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7706,
    style: {
      stopColor: "#6898CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7B7FD7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000012452438618919167670000015260494648000304524_)"
    },
    d: "M226,339l18,42l42,27 c8.7-23.3,17.3-46.7,26-70L226,339z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000155147578914786659640000007881898442765878939_",
    cx: 175.3516,
    cy: 60.7109,
    r: 99.4551,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4EC1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#818CD3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000155147578914786659640000007881898442765878939_)"
    },
    d: "M208,409l-9,36.5l87-37.5L208,409z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000167369667906704803370000003313680879526737802_",
    cx: 167.3297,
    cy: 138.9421,
    r: 122.8851,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4EDD9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9183D6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000167369667906704803370000003313680879526737802_)"
    },
    d: "M208,409l-15-79l32,58L208,409z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000145772745904810799230000018099418771643082907_",
    cx: 171,
    cy: 120.3746,
    r: 139.6697,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#60D0B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#825DD6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000145772745904810799230000018099418771643082907_)"
    },
    d: "M225,388l61,20l-78,1L225,388z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__highlights-3",
    className: "scroll_1_svg__st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M308,336l-38-99l43,100l45,52l-46-47l-18,47l15-49l-31-2L308,336z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M275,462l-12,69l-37-8l36,11l-16,22l20-22l36-12l-36,9L275,462z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__bottom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg___Layer_5"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000126283654521318818970000011349508775045498770_",
    cx: 66.4907,
    cy: -19.7816,
    r: 164.0392,
    gradientTransform: "matrix(1 0 0 -1 0 489.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#617EAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2609,
    style: {
      stopColor: "#657DAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5254,
    style: {
      stopColor: "#7078BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7905,
    style: {
      stopColor: "#8271CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9669E4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000126283654521318818970000011349508775045498770_)"
    },
    d: "M151,585c-1.3,22.3-2.7,44.7-4,67l3-3 l31-56c-1.3-27.7-2.7-55.3-4-83L151,585z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000168805568790174840860000010744221599520779651_",
    cx: 230.6356,
    cy: -82.266,
    r: 89.6682,
    gradientTransform: "matrix(0.9994 -3.375524e-02 -3.375524e-02 -0.9994 15.7918 484.0233)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8756AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2565,
    style: {
      stopColor: "#8658AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5165,
    style: {
      stopColor: "#835CBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7771,
    style: {
      stopColor: "#7E65CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#796EE6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000168805568790174840860000010744221599520779651_)"
    },
    d: "M177,510c0.7,27.3,1.3,54.7,2,82l3,3 l29,18l4,1l-23-26L177,510z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000133531399643767333090000004949659324606943107_",
    cx: 108.6138,
    cy: -118.5304,
    r: 125.1712,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B78D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2757,
    style: {
      stopColor: "#6E74D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5552,
    style: {
      stopColor: "#7668D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8354,
    style: {
      stopColor: "#8354CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8D44C9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000133531399643767333090000004949659324606943107_)"
    },
    d: "M178,665l37-51l-36-22l-1,3 c-0.3,22.7-0.7,45.3-1,68L178,665z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000113312978035425169100000012646514217649798020_",
    cx: 1.2964,
    cy: -139.6629,
    r: 220.8207,
    gradientTransform: "matrix(0.9995 -3.310110e-02 -3.310110e-02 -0.9995 15.6851 484.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#787DD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3109,
    style: {
      stopColor: "#7C7DD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6259,
    style: {
      stopColor: "#887DD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    style: {
      stopColor: "#9C7ECA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A17EC9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000113312978035425169100000012646514217649798020_)"
    },
    d: "M179,592l-32,60l31,13 C178.3,640.7,178.7,616.3,179,592z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "scroll_1_svg__highlights-4",
    className: "scroll_1_svg__st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M179,661l33-43l-34,47l-28-12l27,9c0.3-8,0.7-16,1-24C178.3,645.7,178.7,653.3,179,661z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scroll_1_svg__st8",
    d: "M178,565v27l-12,23l13-23C178.7,583,178.3,574,178,565z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "scroll_1_svg__SVGID_00000065055175065117775120000001034965096342792859_",
    cx: 177.8991,
    cy: 462.624,
    r: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4FEAA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8087FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scroll_1_svg__SVGID_00000065055175065117775120000001034965096342792859_)"
    },
    d: "M177.9,462.6"
  }));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgScroll1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scroll_1.db5ce0b94d06a39b206497b3f386d67e.svg";